// iot-admin/client/src/components/FaceImg.js
// Face-crop <img> that degrades gracefully. Perception crop keys in the DB can
// reference objects that were never uploaded to S3 (device-side crop upload
// gaps) — the presigned URL then 404s. Instead of a broken-image icon we show
// a neutral placeholder, keeping the same sizing via the passed className.

import React, { useState, useEffect } from 'react';
import './FaceImg.css';

export default function FaceImg({ src, alt = '', className = '', title }) {
  const [failed, setFailed] = useState(!src);

  useEffect(() => { setFailed(!src); }, [src]);

  if (failed) {
    return (
      <span
        className={`${className} faceimg-fallback`}
        title={title || 'Image unavailable'}
        aria-label="Image unavailable"
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      title={title}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
